import { useState } from "react";
import { Flag } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogTrigger, DialogDescription } from "@/components/ui/dialog";
import { RadioGroup, RadioGroupItem } from "@/components/ui/radio-group";
import { Textarea } from "@/components/ui/textarea";
import { Label } from "@/components/ui/label";
import { toast } from "sonner";
import { api, errMsg } from "@/lib/api";

const REASONS = ["Harassment or bullying", "Spam or fundraising", "Deceptive or fake ministry", "Divisive theological attack", "Inappropriate or unsafe content", "Concern for someone's safety"];

export function ReportDialog({ targetType, targetId, testId, small }: { targetType: string; targetId: string; testId: string; small?: boolean }) {
  const [open, setOpen] = useState(false);
  const [reason, setReason] = useState(REASONS[0]);
  const [details, setDetails] = useState("");
  const send = async () => {
    try { await api.post("/reports", { target_type: targetType, target_id: targetId, reason, details }); toast.success("Thank you. A moderator will review this."); setOpen(false); }
    catch (e) { toast.error(errMsg(e)); }
  };
  return (
    <Dialog open={open} onOpenChange={setOpen}>
      <DialogTrigger asChild>
        <button data-testid={testId} className={`inline-flex items-center gap-1 text-slate-400 transition-colors hover:text-red-600 ${small ? "text-xs" : "text-sm"}`}><Flag className="h-3.5 w-3.5" />Report</button>
      </DialogTrigger>
      <DialogContent>
        <DialogHeader><DialogTitle className="font-display text-2xl">Report this {targetType}</DialogTitle><DialogDescription>Reports are private. The author won't know who reported.</DialogDescription></DialogHeader>
        <RadioGroup value={reason} onValueChange={setReason} className="space-y-1">
          {REASONS.map((r, i) => <div key={r} className="flex items-center gap-2"><RadioGroupItem value={r} id={`r${i}`} data-testid={`report-reason-${i}`} /><Label htmlFor={`r${i}`}>{r}</Label></div>)}
        </RadioGroup>
        <Textarea data-testid="report-details-input" value={details} onChange={(e) => setDetails(e.target.value)} placeholder="Anything else we should know? (optional)" />
        <Button data-testid="report-submit-button" onClick={send} className="rounded-full bg-[#1E293B]">Send report</Button>
      </DialogContent>
    </Dialog>
  );
}
